import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { useCallback, useEffect, useRef, useState } from 'react';
import IconSwitch from '../components/Switch';
import WrapperStatisticsRemises from '../components/WrapperStatisticsRemises';
import WrapperStatisticsBuses from '../components/WrapperStatisticsBuses';
import { BusType } from '../../viajeTraslado/models/TransferReservation';
import useViajesTraslado from '../../viajeTraslado/services/ViajeTrasladoService';
import { createTableScrollHandler } from 'utils/tableUtils';

export const AnalisisComercialPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [enabledBuses, setEnabledBuses] = useState(false);
  const [optionsBuses, setOptionsBuses] = useState<BusType[]>([]);
  const { getOptionsBuses } = useViajesTraslado();

  const onChangeEnabledBuses = useCallback(() => {
    setEnabledBuses((enabledBuses) => !enabledBuses);
  }, []);

  const onLoadTypeBuses = async () => {
    const res = await getOptionsBuses();
    setOptionsBuses(res);
  };

  useEffect(() => {
    onLoadTypeBuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={tableRef}>
      <PageHeader
        area=" Estadísticas"
        title="Analisis Comercial"
        subArea={enabledBuses ? '/ Servicios grupales' : '/ Remises'}
        toolbar={
          <IconSwitch
            enabled={enabledBuses}
            onChangeEnabledBuses={onChangeEnabledBuses}
          />
        }
      />
      <PageContainer lessMargin>
        {!enabledBuses ? (
          <WrapperStatisticsRemises  handlePageChange={createTableScrollHandler(tableRef)}/>
        ) : (
          <WrapperStatisticsBuses optionsBuses={optionsBuses} handlePageChange={createTableScrollHandler(tableRef)}/>
        )}
      </PageContainer>
    </div>
  );
};
